import { Suspense } from 'react';
import Scene3D from '../../components/3d/Scene3D';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import EffectsSection from './components/EffectsSection';
import PackagesSection from './components/PackagesSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="relative min-h-screen bg-black text-white overflow-x-hidden">
      <Suspense fallback={<div className="fixed inset-0 bg-black"></div>}>
        <Scene3D />
      </Suspense>
      
      <Navbar />
      
      <main>
        <HeroSection />
        <ServicesSection />
        <EffectsSection />
        <PackagesSection />
        <ContactSection />
      </main>
      
      <Footer />
    </div>
  );
}
